import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { isNil } from 'lodash';

import { NgChanges } from '../../../../common/objects/ng-changes';
import { HowlerPlayer } from '../../../../common/sound/howler-player';

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.scss'],
})
export class AudioPlayerComponent implements OnInit, OnChanges, OnDestroy {
  ///////////////////////////////////////////////////////////////////////
  // Input
  ///////////////////////////////////////////////////////////////////////

  @Input() playURL: string;

  @Input() public autoplay: boolean = false;

  ///////////////////////////////////////////////////////////////////////
  // Variables
  ///////////////////////////////////////////////////////////////////////

  currentPosSeconds = 0;

  howlerPlayer: HowlerPlayer;

  ///////////////////////////////////////////////////////////////////////
  // Lifecycle Component
  ///////////////////////////////////////////////////////////////////////

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngOnChanges(changes: NgChanges<AudioPlayerComponent>) {
    if (changes.playURL.currentValue !== changes.playURL.previousValue) {
      this.howlerPlayer?.cleanup();
      this.setupPlayer();
    }
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.howlerPlayer?.cleanup();
  }

  ///////////////////////////////////////////////////////////////////////
  // Audio Lifecycle
  ///////////////////////////////////////////////////////////////////////

  setupPlayer() {
    if (isNil(this.howlerPlayer)) {
      this.howlerPlayer = new HowlerPlayer(this.playURL);
      this.howlerPlayer.onPlay().subscribe((progress) => {
        if (Math.round(10 * progress.secsPlayed) !== Math.round(10 * this.currentPosSeconds)) {
          this.currentPosSeconds = progress.secsPlayed;
          this.changeDetectorRef.detectChanges();
        }
      });

      if (this.autoplay && this.playURL) {
        this.howlerPlayer.play();
        this.changeDetectorRef.detectChanges();
      }
    }
  }

  play() {
    this.setupPlayer();
    this.howlerPlayer.play();
    this.changeDetectorRef.detectChanges();
  }

  onSliderChange(value: number) {
    this.pause();
    this.howlerPlayer.seekToSeconds(value);
    this.play();
  }

  pause() {
    this.howlerPlayer.pause();
    this.changeDetectorRef.detectChanges();
  }
}
